import React from 'react';

const EditIcon = ({ color }) => {
  return (
    <svg version="1.1" id="Layer_1" width="17px" viewBox="0 0 1000 881.9">
      <g id="Group_9552" transform="translate(0 0)">
        <path
          fill={color}
          id="Path_14242"
          className="st0"
          d="M435.4,107.7H87.3C42,104.9,3,139.2,0,184.5v620.4c3,45.3,42,79.6,87.3,76.9h690.5
      c45.2,2.6,84.1-31.7,87.1-76.9V521.6c-2.6-20.6-21.4-35.2-42-32.6c-17.1,2.1-30.5,15.6-32.6,32.6v283.3c-0.4,6.4-5.9,11.4-12.4,11
      c0,0-0.1,0-0.1,0H87.3c-6.4,0.4-12-4.4-12.5-10.9c0,0,0-0.1,0-0.1V184.5c0.4-6.4,5.9-11.4,12.4-11c0,0,0.1,0,0.1,0h348.1
      c19.3,1.3,36-13.4,37.3-32.7c0-0.1,0-0.1,0-0.2c-1.2-19.3-17.8-34.1-37.1-32.9C435.5,107.7,435.4,107.7,435.4,107.7z M975,247
      c29.8-25.2,33.5-69.7,8.4-99.5c-2.5-3-5.3-5.8-8.4-8.4L845.3,22.9c-35.7-30.6-88.3-30.6-124,0L257.9,438.2
      c-6,5.2-9.8,12.5-10.6,20.4l-18.8,197.8c-0.8,10,3.3,19.8,11,26.2c8.3,7,19,10.3,29.8,9.3l218.3-18.9c8.5-0.7,16.5-4.1,22.9-9.7
      L975,247z M921.8,200.8l-455,407.8l-160.3,13.9l13.9-146.2L774.4,69.4c5.1-4.3,12.5-4.3,17.5,0l129.7,116.3
      c4.2,3.6,4.7,10,1.1,14.2C922.5,200.2,922.1,200.5,921.8,200.8z"
        />
      </g>
    </svg>
  );
};

export default EditIcon;
